import React, { createContext, ReactNode, useContext, useState } from "react";
import TokenExpiryWatcher from "@app/ups/components/tokenExpiryWatcher";

export interface UPSSessionContextType {
  expireTime: number | null;
  setExpireTime: (time: number | null) => void;
}

export const UPSSessionContext = createContext<UPSSessionContextType>({
  expireTime: null,
  setExpireTime: () => {},
});

interface UPSSessionProviderProps {
  children: ReactNode;
}

const UPSSessionProvider: React.FC<UPSSessionProviderProps> = ({
  children,
}) => {
  const [expireTime, setExpireTime] = useState<number | null>(null);

  return (
    <UPSSessionContext.Provider value={{ expireTime, setExpireTime }}>
      <TokenExpiryWatcher expireTime={expireTime}>
        {children}
      </TokenExpiryWatcher>
    </UPSSessionContext.Provider>
  );
};

export const useUPSSessionProvider = () => {
  const context = useContext(UPSSessionContext);
  return context;
};

export default UPSSessionProvider;
